var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconTrash = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62476 4.87402H9.49976C9.56851 4.87402 9.62476 4.81777 9.62476 4.74902V4.87402H14.3748V4.74902C14.3748 4.81777 14.431 4.87402 14.4998 4.87402H14.3748V5.99902H15.4998V4.74902C15.4998 4.19746 15.0513 3.74902 14.4998 3.74902H9.49976C8.94819 3.74902 8.49976 4.19746 8.49976 4.74902V5.99902H9.62476V4.87402ZM17.4998 5.99902H6.49976C6.22319 5.99902 5.99976 6.22246 5.99976 6.49902V6.99902C5.99976 7.06777 6.05601 7.12402 6.12476 7.12402H7.06851L7.45444 15.2959C7.47944 15.8287 7.92007 16.249 8.45288 16.249H15.5466C16.081 16.249 16.5201 15.8303 16.5451 15.2959L16.931 7.12402H17.8748C17.9435 7.12402 17.9998 7.06777 17.9998 6.99902V6.49902C17.9998 6.22246 17.7763 5.99902 17.4998 5.99902ZM15.4263 15.124H8.57319L8.19507 7.12402H15.8044L15.4263 15.124Z",
    fill: "#ACACAC"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-trash.bfe6ac4b.svg";
export { ForwardRef as ReactComponent };